import { SupportedLocale } from '@afterpay/types'
import { TFunction } from 'i18next'
import { MAX_AMOUNT, MIN_AMOUNT } from './constants'

export const formatAmountForDisplay = (amount: number, locale?: SupportedLocale): string => {
  return amount.toLocaleString(locale)
}

/**
 * Gets the validation error message for the amount
 * If undefined, the amount is valid
 * @param amount - The amount to validate
 * @param t - The translation function
 * @param locale - The locale
 * @returns The validation error message or undefined if the amount is valid
 */
export const getValidationError = (amount: string, t: TFunction, locale?: SupportedLocale): string | undefined => {
  if (amount === '' || amount === '0') {
    return undefined
  }

  const numericAmount = parseFloat(amount)
  if (isNaN(numericAmount)) {
    return undefined
  }

  if (numericAmount < MIN_AMOUNT) {
    return t('adjustAmount:error.minimumNotMet', { minimum: formatAmountForDisplay(MIN_AMOUNT, locale) })
  }

  if (numericAmount > MAX_AMOUNT) {
    return t('adjustAmount:error.maximumExceeded', { maximum: formatAmountForDisplay(MAX_AMOUNT, locale) })
  }

  return undefined
}

export const getAmountError = (amount: string, t: TFunction, locale?: SupportedLocale): string | undefined => {
  const numericAmount = parseFloat(amount)
  const isValidFormat = /^\d+(\.\d{1,2})?$/.test(String(amount))

  if (amount === '' || isNaN(numericAmount) || !isValidFormat) {
    return t('adjustAmount:error.empty')
  }

  if (numericAmount < MIN_AMOUNT || numericAmount > MAX_AMOUNT) {
    return t('adjustAmount:error.outsideRange', { minimum: formatAmountForDisplay(MIN_AMOUNT, locale), maximum: formatAmountForDisplay(MAX_AMOUNT, locale) })
  }

  return undefined
}
